"use client";
import { createContext, useContext } from "react";

// Signals to descendant popovers (notably ConversationPersonPopoverPaginated)
// that they should opt into @focal/ui-kit's forcePortal escape hatch. Needed
// when the transcript is rendered inside an open Dialog: ui-kit's auto-detect
// would otherwise inline the popover content into a virtualized list and
// corrupt the layout.
const TranscriptForcePortalContext = createContext(false);

export const TranscriptForcePortalProvider = TranscriptForcePortalContext.Provider;

export const useTranscriptForcePortal = () =>
  useContext(TranscriptForcePortalContext);
